
import { Loader2 } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface StatusSelectorProps {
  status: string;
  isUpdating: boolean;
  onStatusChange: (newStatus: string) => void;
}

const StatusSelector = ({ status, isUpdating, onStatusChange }: StatusSelectorProps) => {
  return (
    <div className="relative">
      <Select 
        value={status} 
        onValueChange={onStatusChange}
        disabled={isUpdating}
      >
        <SelectTrigger className="w-[130px] h-8 text-xs">
          <SelectValue placeholder="Change status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="pending">Pending</SelectItem>
          <SelectItem value="approved">Approved</SelectItem>
          <SelectItem value="denied">Denied</SelectItem>
          <SelectItem value="resolved">Resolved</SelectItem>
        </SelectContent>
      </Select>
      
      {isUpdating && (
        <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
          <Loader2 className="h-3 w-3 animate-spin text-primary" />
        </div>
      )}
    </div>
  );
};

export default StatusSelector;
